import { MeasuringStrategy } from '@dnd-kit/core'

// Popper が上に反転表示されると dnd-kit の layoutShiftCompensation が誤発火して
// 意図しないスクロールが起きるため無効化する(autoScroll={false} だけでは無効化されない)
export const DND_AUTO_SCROLL_CONFIG = {
  layoutShiftCompensation: false,
}

export const DND_MEASURING_CONFIG = {
  droppable: { strategy: MeasuringStrategy.Always },
}
